import React from "react";

function KeyButton({ className, icon, onClick }: any) {
  return (
    <button
      className={className}
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => onClick()}
    >
      {icon}
    </button>
  );
}

export default KeyButton;
